import { PageContext } from 'hooks/shared/usePageContext.types';
import { CANDIDATE_STATUS } from 'services/candidates';
import {
  decreaseStatCount,
  increaseStatCount,
  updateCandidateAtSharedAndCandidate,
  updateCandidateQueries,
} from 'services/query-cache/updates';
import { CampaignTab } from 'shared/legacy/contexts/SelectedCampaignContext/SelectedCampaignContext.types';
import { QueryKey } from 'types/query';
import { getPageContext } from 'utils/getPageContext';

export function moveCandidateToContacted(esPersonId: string, fromStatus: string) {
  const pageContext = getPageContext();
  const isCampaignPage = pageContext === PageContext.Campaign || pageContext === PageContext.RatedCandidates;

  if (isCampaignPage) {
    const queryKeysToUpdate = [QueryKey.useRatedCandidatesQuery, QueryKey.selectedCampaignContextUseCandidates];

    updateCandidateQueries(queryKeysToUpdate, esPersonId, { status: CANDIDATE_STATUS.CONTACTED });
    updateCandidateQueries(queryKeysToUpdate, esPersonId, {}, { remove: true });

    if (fromStatus === CANDIDATE_STATUS.NEW) {
      decreaseStatCount(CampaignTab.New);
    } else if (fromStatus === CANDIDATE_STATUS.SHORTLISTED) {
      decreaseStatCount(CampaignTab.Shortlisted);
    }

    increaseStatCount(CampaignTab.Contacted);
  } else if (pageContext === PageContext.Shared || pageContext === PageContext.Candidate) {
    updateCandidateAtSharedAndCandidate(esPersonId, { status: CANDIDATE_STATUS.CONTACTED });
  }
}
